import { LicentiateCertificateReducer, LicentiateCertificateSubMenuReducer, MonthDDLReducer, Optional_Subject_ListReducer, Week_Category_ListReducer, YearDDLReducer } from "./Slices/DDLSlice/DDLSlice";
import { ExamFormDetailsPostReducer } from "./Slices/ExamFormDetailsSlice/ExamFormDetailsSlice";
import { Export_ExaminationForm_SelectReducer, GET_T_ExaminationForm_SelectReducer } from "./Slices/GridAPISlice";

export const rootreducer = {
    //DDLSlices
    LicentiateCertificateData: LicentiateCertificateReducer,
    LicentiateCertificateSubMenuData: LicentiateCertificateSubMenuReducer,
    Optional_Subject_ListData: Optional_Subject_ListReducer,
    Week_Category_ListData:Week_Category_ListReducer,

    // Slices

    ExamFormDetailsPostData: ExamFormDetailsPostReducer,


    // Admin

    YearDDLData: YearDDLReducer,
    MonthDDLData: MonthDDLReducer,

    GET_T_ExaminationForm_SelectData: GET_T_ExaminationForm_SelectReducer,
    Export_ExaminationForm_SelectData: Export_ExaminationForm_SelectReducer,
};
